var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center padd30t padd30b"},[_c('button',{staticClass:"btn is-btn-primary shop-button btn-block shop-payment-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('submit')}}},[_c('i',{staticClass:"fas fa-receipt"}),_vm._v(" "+_vm._s(_vm.__('webapp.continue_to_payment'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }